// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see BenefitsHubViewErrorEvent
 */
export var BenefitsHubViewError = function () { return ({
    name: "BenefitsHub View Error",
    parameters: {
        cdf_entity: "BenefitsHub",
        cdf_action: "View",
    }
}); };
/**
 * @see BenefitsHubTapStartBenefitEvent
 */
export var BenefitsHubTapStartBenefit = function (_a) {
    var benefit = _a.benefit;
    return ({
        name: "BenefitsHub Tap StartBenefit",
        parameters: {
            cdf_entity: "BenefitsHub",
            cdf_action: "Tap",
            benefit: benefit !== undefined && benefit !== null ? benefit.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see BenefitsHubTapLearnMoreEvent
 */
export var BenefitsHubTapLearnMore = function () { return ({
    name: "BenefitsHub Tap LearnMore",
    parameters: {
        cdf_entity: "BenefitsHub",
        cdf_action: "Tap",
    }
}); };
/**
 * @see BenefitsHubTapSetupDirectDepositEvent
 */
export var BenefitsHubTapSetupDirectDeposit = function () { return ({
    name: "BenefitsHub Tap SetupDirectDeposit",
    parameters: {
        cdf_entity: "BenefitsHub",
        cdf_action: "Tap",
    }
}); };
/**
 * @see BenefitsHubScrollDidScrollToBottomEvent
 *
 * @deprecated This event is obsolete. Use `ScrolledThrough` instead.
 */
export var BenefitsHubScrollDidScrollToBottom = function () { return ({
    name: "BenefitsHub Scroll DidScrollToBottom",
    parameters: {
        cdf_entity: "BenefitsHub",
        cdf_action: "Scroll",
    }
}); };
/**
 * @see BenefitsHubScrollScrolledThroughEvent
 */
export var BenefitsHubScrollScrolledThrough = function (_a) {
    var progress = _a.progress;
    return ({
        name: "BenefitsHub Scroll ScrolledThrough",
        parameters: {
            cdf_entity: "BenefitsHub",
            cdf_action: "Scroll",
            progress: progress.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH)
        }
    });
};
